import Image from 'next/image'
import links from '../../config/links'
import useUser from '../../lib/useUser'
import InfoItem from '../common/InfoItem'
import ChatAction from '../profile/user/actions/ChatAction'
import { useTranslation } from '../../lib/i18n'

const HomeFeedEmpty = () => {
  const { user } = useUser()
  const { t } = useTranslation()

  const isUserNew = () => {
    if (!user?.onboarded_at) return false

    const onboardedDate = new Date(user.onboarded_at)
    const currentDate = new Date()
    const differenceInHours = (currentDate - onboardedDate) / (1000 * 60 * 60)

    return differenceInHours <= 48
  }

  const title = isUserNew()
    ? t('welcome.titles.newUser')
    : t('welcome.titles.default')

  return (
    <div className="flex flex-col w-full mb-4 px-2 md:px-0">
      <h2 className="text-xl font-bold mb-2">{title}</h2>
      <div className="bg-white rounded-lg p-4 mb-4">
        <div className="flex flex-row gap-2">
          <Image
            key={t('welcome.founder.name')}
            src={t('welcome.founder.avatar')}
            alt={`${t('welcome.founder.name')} avatar`}
            width={60}
            height={60}
            priority
            className="rounded-full w-24 h-24"
          />
          <div className="flex flex-col">
            <p className="text-sm text-gray-600 my-1">
              {t('welcome.founder.intro')}
            </p>
            <p className="text-sm text-gray-600 my-1">
              {t('welcome.founder.cta')}
            </p>
          </div>
        </div>
        <div className="flex flex-row align-middle items-center w-fill justify-end gap-4 mt-2">
          <a
            target="_blank"
            className="text-gray-600 underline text-sm cursor-pointer"
            href={links.andrewEmail}
            rel="noreferrer"
          >
            {t('welcome.founder.emailLabel')}
          </a>
          {links.andrewProfileId && (
            <ChatAction profileId={links.andrewProfileId} />
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 w-full mb-2">
        {t('home.empty.infoItems').map((item, index) => (
          <InfoItem
            key={index}
            href={(() => {
              if (item.href === 'links.clCluster') return links.clCluster
              if (item.href === 'links.supportGroup') return links.supportGroup
              return item.href
            })()}
            icon={item.icon}
            title={item.title}
            bgColor={item.bgColor}
            text={item.text}
          />
        ))}
      </div>
      <p className="text-gray-600 text-center mt-2 italic">
        {t('home.empty.footerText')}
      </p>
    </div>
  )
}

export default HomeFeedEmpty
